import { render, staticRenderFns } from "./cancelOrder.vue?vue&type=template&id=15a6c25c&scoped=true&"
import script from "./cancelOrder.vue?vue&type=script&lang=js&"
export * from "./cancelOrder.vue?vue&type=script&lang=js&"
import style0 from "./cancelOrder.vue?vue&type=style&index=0&id=15a6c25c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a6c25c",
  null
  
)

component.options.__file = "cancelOrder.vue"
export default component.exports